import { useEffect, useState } from "react";
import { Card, CardBody, Table, TableHeader, TableBody, TableColumn, TableRow, TableCell, Button, Modal, ModalBody, ModalHeader, ModalFooter, Input, Textarea, ScrollShadow, ModalContent, Spinner } from "@heroui/react";
import { FolderPlus, BarChart, PlusCircle, TagIcon, Trash2Icon } from "lucide-react";
import { motion } from "framer-motion";
import { useToast } from "../../context/toast";
import api from "../../api/api";
import WarningModal from "../../components/Modal/warning";

export default function CategoriesSection() {
  const [categories, setCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showToast = useToast()
  const [isOpen, setIsOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [selectedId, setSelected] = useState(null)
  // 📌 Gérer l'ajout d'une nouvelle catégorie


  const handleDeleteCategory = async (id)=>{


    try{
      
        setIsDeleting(true)
        await api.category.delete({id : selectedId})

        setCategories((prev)=>([...prev.filter((dt)=>dt.id !== selectedId)]))
        setIsDeleting(false)
        setSelected(null)
        
    }catch(e){
        console.log(e)
        setIsDeleting(false)
    }

  }


  const handleAddCategory = async () => {

    if (!name) return;


    try{

        const rep = await api.category.create({name : name, description : description})

        setCategories((prev)=>[...prev, {...rep, stats: { produits: 0, ventes: 0 }}])

        showToast("Categorie créée avec success", "success")
        setIsModalOpen(false)

        setName(null)
        setdescription(null)


    }catch(e){

        showToast("Une erreur s'est produite", "error")

    }

  };

  const [name, setName] = useState()
  const [description, setdescription] = useState()

  useEffect(()=>{

    const fetch = async ()=>{

        try{

            const data = await api.category.read()

            setCategories(data)


        }catch(e){

            console.log(e)

        }
    }

    fetch()

  }, [])


  

  return (
    <div className="p-6 space-y-6">
      {/* 📌 HEADER */}
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-2xl font-semibold">
          <TagIcon size={24} className="text-primary" /> Catégories & Statistiques
        </h2>
        <Button color="primary" onPress={() => setIsModalOpen(true)}>
          <PlusCircle size={18} className="mr-2" /> Ajouter une Catégorie
        </Button>
      </div>

      {/* 📌 LISTE DES CATÉGORIES AVEC SCROLL INTERNE */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
          <Table 

            aria-label="Table des catégories"
            isHeaderSticky 
            loadingContent={<Spinner color="primary" />}
            isStriped 
            classNames={{
              base: "max-h-[60vh]",
            }}
          >
            <TableHeader>
              <TableColumn>ID</TableColumn>
              <TableColumn>Nom</TableColumn>
              <TableColumn>Description</TableColumn>
              <TableColumn>Actions</TableColumn>
              {/* <TableColumn>Produits</TableColumn>
              <TableColumn>Ventes</TableColumn> */}
            </TableHeader>
            <TableBody emptyContent={'No product found'}>
              {categories.map((cat) => (

                <TableRow key={cat.id}>
                  <TableCell>{cat.id}</TableCell>
                  <TableCell>{cat.name}</TableCell>
                  <TableCell>{cat.description}</TableCell>
                  <TableCell><Button isIconOnly isLoading={selectedId === cat.id} onPress={()=>{setSelected(cat.id) ; setIsOpen(true)}}  size="sm" className="bg-red-100"><Trash2Icon className="w-4 h-4 text-red-700"/></Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </motion.div>

      <WarningModal
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        title="Suppression d'un produit"
        message="Cette action supprimera définitivement le produit. Êtes-vous sûr ?"
        onConfirm={handleDeleteCategory}
      />

      {/* 📌 MODAL AJOUT CATÉGORIE */}
      <Modal isOpen={isModalOpen} onOpenChange={() => setIsModalOpen(false)} isDismissable>
        <ModalContent>
            <ModalHeader>
            <FolderPlus size={24} className="mr-2 text-primary" /> Ajouter une Catégorie
            </ModalHeader>
            <ModalBody>
            <input
                label="Nom de la Catégorie"
                placeholder="Ex: Produits Bio"
                value={name || ''}
                className="p-2 border rounded-lg shadow-sm focus:outline-primary"
                onChange={(e) => setName( e.target.value)}
                isRequired
            />
            <textarea
                label="Description"
                placeholder="Décrivez la catégorie"
                value={description || ''}
                onChange={(e) => setdescription(e.target.value)}
                className="p-2 border rounded-lg shadow-sm focus:outline-primary"
            />
            </ModalBody>
            <ModalFooter>
            <Button color="primary" onPress={handleAddCategory}>Ajouter</Button>
            </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}
